(() => {
  // src/product-card-generic.ts
  (() => {
    if (window.__pcgVideoInit) return;
    window.__pcgVideoInit = true;
    const pending = /* @__PURE__ */ new WeakMap();
    const playVideo = (video) => {
      video.currentTime = 0;
      const promise = video.play().catch(() => {
      });
      pending.set(video, promise);
    };
    document.addEventListener("mouseenter", (e) => {
      if (!(e.target instanceof Element)) return;
      if (!e.target.classList.contains("product-card-generic")) return;
      const video = e.target.querySelector(".product-card-generic__video");
      if (!video) return;
      video.loop = true;
      playVideo(video);
    }, true);
    document.addEventListener("mouseleave", (e) => {
      if (!(e.target instanceof Element)) return;
      if (!e.target.classList.contains("product-card-generic")) return;
      const video = e.target.querySelector(".product-card-generic__video");
      if (!video) return;
      const promise = pending.get(video);
      if (promise) {
        promise.then(() => video.pause());
        pending.delete(video);
      } else {
        video.pause();
      }
    }, true);
  })();
})();
